(() => {
  const sideActions = document.querySelector(".side-actions");
  if (!sideActions) return;

  const root = document.documentElement;
  const revealProgress = 0.4;
  const interactionEvents = ["pointerdown", "keydown", "touchstart"];
  const directionThreshold = 10;
  const topBoundary = 8;
  let anchorScrollY = Math.max(window.pageYOffset || root.scrollTop, 0);
  let revealed = false;
  let hidden = true;
  let ticking = false;

  const syncVisibility = () => {
    sideActions.classList.toggle("side-actions--hidden", hidden);
    sideActions.classList.toggle("side-actions--pending", !revealed);
    root.classList.toggle("divoom-floating-actions-hidden", hidden);
  };

  const getScrollProgress = () => {
    const scrollable = root.scrollHeight - window.innerHeight;
    return scrollable > 0 ? window.scrollY / scrollable : 1;
  };

  const revealActions = () => {
    if (revealed) return;
    revealed = true;
    hidden = false;
    anchorScrollY = Math.max(window.pageYOffset || root.scrollTop, 0);
    window.removeEventListener("scroll", checkRevealScrollDepth);
    interactionEvents.forEach((eventName) => {
      window.removeEventListener(eventName, revealActions, { passive: true });
    });
    syncVisibility();
  };

  const checkRevealScrollDepth = () => {
    if (getScrollProgress() >= revealProgress) revealActions();
  };

  const updateVisibility = () => {
    ticking = false;
    if (!revealed) {
      checkRevealScrollDepth();
      return;
    }

    const currentScrollY = Math.max(window.pageYOffset || root.scrollTop, 0);

    if (currentScrollY <= topBoundary) {
      anchorScrollY = currentScrollY;
      hidden = false;
      syncVisibility();
      return;
    }

    const delta = currentScrollY - anchorScrollY;
    if (Math.abs(delta) >= directionThreshold) {
      hidden = delta > 0;
      anchorScrollY = currentScrollY;
    }

    syncVisibility();
  };

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    },
    { passive: true }
  );

  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, revealActions, { once: true, passive: true });
  });

  checkRevealScrollDepth();
  syncVisibility();
})();
